import { Box, Center, Loader } from '@mantine/core';

export const PageLoading = () => (
  <Box w='100vw' h='100vh' p='xl'>
    <Center>
      <Loader />
    </Center>
  </Box>
);
